var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { errors } from '@feathersjs/client';
import * as Raven from 'raven-js';
import Card from 'antd/lib/card';
import 'antd/lib/card/style/index.css';
import Divider from 'antd/lib/divider';
import 'antd/lib/divider/style/index.css';
import Form from 'antd/lib/form';
import 'antd/lib/form/style/index.css';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import 'antd/lib/grid/style/index.css';
import message from 'antd/lib/message';
import 'antd/lib/message/style/index.css';
import InputName from './InputName';
import InputCategory from './InputCategory';
import InputAthlete from './InputAthlete';
import ListAthlete from './ListAthlete';
import ButtonSubmit from 'src/pages/components/forms/ButtonSubmit';
import ButtonCancel from 'src/pages/components/forms/ButtonCancel';
import ButtonDelete from 'src/pages/components/forms/ButtonDelete';
var formStyles = require('src/imports/styles/extend.form.scss');
var FormTeam = (function (_super) {
    __extends(FormTeam, _super);
    function FormTeam(props) {
        var _this = _super.call(this, props) || this;
        _this.state = __assign({}, _this.filterData(props, props.teamDoc), { isFetching: false });
        _this.handleSetCategory = _this.handleSetCategory.bind(_this);
        _this.handleAddAthlete = _this.handleAddAthlete.bind(_this);
        _this.handleRemoveAthlete = _this.handleRemoveAthlete.bind(_this);
        _this.handleSubmitForm = _this.handleSubmitForm.bind(_this);
        return _this;
    }
    FormTeam.prototype.componentWillReceiveProps = function (nextProps) {
        var currTeam = this.props.teamDoc;
        var nextTeam = nextProps.teamDoc;
        if (!currTeam && !nextTeam) {
        }
        else if (currTeam && !nextTeam) {
            this.props.form.resetFields();
            this.setState(this.filterData(nextProps, nextTeam));
        }
        else if ((!currTeam && nextTeam) ||
            (currTeam && nextTeam && currTeam.id !== nextTeam.id)) {
            this.props.form.setFieldsValue({
                categoryId: nextTeam.categoryId,
                name: nextTeam.name,
            });
            this.setState(this.filterData(nextProps, nextTeam));
        }
    };
    FormTeam.prototype.filterData = function (props, team) {
        var categoryDoc = team
            ? props.categories.find(function (c) { return c.id === team.categoryId; })
            : undefined;
        var athleteDocs = team
            ? props.athletes.filter(function (a) { return a.teamId === team.id; })
            : [];
        return {
            categoryDoc: categoryDoc,
            addAthleteDocs: athleteDocs,
            removeAthleteDocs: [],
        };
    };
    FormTeam.prototype.handleSetCategory = function (categoryId) {
        var categoryDoc = this.props.categories.find(function (c) { return c.id === categoryId; });
        this.setState({
            categoryDoc: categoryDoc,
            addAthleteDocs: [],
            removeAthleteDocs: [],
        });
    };
    FormTeam.prototype.handleAddAthlete = function (athleteId) {
        var athlete = this.props.athletes.find(function (a) { return a.id === athleteId; });
        if (athlete) {
            this.setState({
                addAthleteDocs: this.state.addAthleteDocs.concat([
                    athlete,
                ]),
            });
        }
    };
    FormTeam.prototype.handleRemoveAthlete = function (athleteId) {
        var prevAthletes = this.state.addAthleteDocs;
        var index = prevAthletes.findIndex(function (a) { return a.id === athleteId; });
        var athlete = prevAthletes[index];
        this.setState({
            addAthleteDocs: prevAthletes.slice(0, index).concat(prevAthletes.slice(index + 1)),
            removeAthleteDocs: this.state.removeAthleteDocs.concat([
                athlete,
            ]),
        });
    };
    FormTeam.prototype.handleSubmitForm = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var formValues_1, category, team, teamResponse, _a, addAthletes, removeAthletes, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        e.preventDefault();
                        this.setState({ isFetching: true });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 7, , 8]);
                        return [4, new Promise(function (resolve, reject) {
                                _this.props.form.validateFieldsAndScroll({ scroll: { offsetTop: 96 } }, function (err, res) {
                                    if (err) {
                                        reject(err);
                                    }
                                    if (!err) {
                                        resolve(res);
                                    }
                                });
                            })];
                    case 2:
                        formValues_1 = _b.sent();
                        category = this.props.categories.find(function (c) { return c.id === formValues_1.categoryId; });
                        if (!category) {
                            throw new errors.BadRequest('Please select a valid category');
                        }
                        if (!category.isTeamCategory) {
                            throw new errors.BadRequest('Selected category is not a team-scoring category');
                        }
                        team = {
                            id: this.props.teamDoc && this.props.teamDoc.id,
                            eventId: this.props.event.id,
                            categoryId: (this.props.teamDoc && this.props.teamDoc.categoryId) || formValues_1.categoryId,
                            name: formValues_1.name,
                        };
                        if (!this.props.teamDoc) return [3, 4];
                        return [4, this.props.handlePatchTeam(team)];
                    case 3:
                        _a = _b.sent();
                        return [3, 6];
                    case 4: return [4, this.props.handleCreateTeam(team)];
                    case 5:
                        _a = _b.sent();
                        _b.label = 6;
                    case 6:
                        teamResponse = _a;
                        addAthletes = this.state.addAthleteDocs.map(function (a) { return a.id; });
                        removeAthletes = this.state.removeAthleteDocs.map(function (a) { return a.id; });
                        if (removeAthletes.length > 0) {
                            this.props.handlePatchAthletes(removeAthletes, {
                                teamId: null,
                            });
                            this.props.handlePatchAthleteScores(null, {
                                teamId: null,
                            }, {
                                $query: {
                                    athleteId: { $in: removeAthletes },
                                },
                            });
                        }
                        if (addAthletes.length > 0) {
                            this.props.handlePatchAthletes(addAthletes, {
                                teamId: teamResponse.value.id,
                            });
                            this.props.handlePatchAthleteScores(null, {
                                teamId: teamResponse.value.id,
                            }, {
                                query: {
                                    athleteId: { $in: addAthletes },
                                },
                            });
                        }
                        this.setState({ isFetching: false });
                        message.success('Team was successfully saved!');
                        if (!this.props.teamDoc) {
                            this.props.navigateTo("/event/" + this.props.event.subdomain + "/teams");
                        }
                        return [3, 8];
                    case 7:
                        err_1 = _b.sent();
                        this.setState({ isFetching: false });
                        Raven.captureException(err_1);
                        if (err_1.message) {
                            message.error(err_1.message);
                        }
                        else {
                            message.error('There are several errors in your data. Please correct them');
                        }
                        return [3, 8];
                    case 8: return [2];
                }
            });
        });
    };
    FormTeam.prototype.render = function () {
        var _this = this;
        var form = this.props.form;
        var teamDoc = this.props.teamDoc;
        var isFetching = this.state.isFetching;
        return (React.createElement(Form, { className: formStyles.form, hideRequiredMark: true, onSubmit: this.handleSubmitForm },
            React.createElement(Row, { gutter: 24 },
                React.createElement(Col, { xs: {
                        span: 24,
                        push: 0,
                    }, xl: {
                        span: 8,
                        push: 16,
                    } },
                    React.createElement(Card, { className: formStyles.card },
                        React.createElement("h2", { className: formStyles.header }, "Category"),
                        React.createElement(InputCategory, { form: form, initialValue: teamDoc && teamDoc.categoryId, isDisabled: isFetching, categories: this.props.categories, handleSetCategory: this.handleSetCategory }))),
                React.createElement(Col, { xs: {
                        span: 24,
                        pull: 0,
                    }, xl: {
                        span: 16,
                        pull: 8,
                    } },
                    React.createElement(Card, { className: formStyles.card },
                        React.createElement("h2", { className: formStyles.header }, "Team Info"),
                        React.createElement(InputName, { form: form, initialValue: teamDoc && teamDoc.name, isDisabled: isFetching })))),
            React.createElement(Row, { gutter: 24 },
                React.createElement(Col, { xs: 24, xl: 16 },
                    React.createElement(Card, { className: formStyles.card },
                        React.createElement("h2", { className: formStyles.header }, "Athletes in this Team"),
                        React.createElement(ListAthlete, { isDisabled: isFetching, event: this.props.event, athleteDocs: this.state.addAthleteDocs, handleRemoveAthlete: this.handleRemoveAthlete }),
                        React.createElement(InputAthlete, { isDisabled: isFetching, categoryDoc: this.state.categoryDoc, athleteDocs: this.props.athletes, excludeAthleteDocs: this.state.addAthleteDocs, handleAddAthlete: this.handleAddAthlete })))),
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Divider, null),
                    React.createElement("div", { className: formStyles.buttonsWrapper },
                        React.createElement("div", { className: formStyles.buttonsLeft },
                            teamDoc && (React.createElement(Form.Item, null,
                                React.createElement(ButtonDelete, { isDisabled: isFetching, action: function () { return _this.props.handleDeleteTeam(teamDoc); }, deleteTitle: 'Delete team?', deleteContent: React.createElement("div", null,
                                        React.createElement("p", null,
                                            "This will delete this team, ",
                                            React.createElement("strong", null, teamDoc.name),
                                            ", and will remove links to athletes that are in this team. You can add these orphaned athletes into other teams"),
                                        " ",
                                        React.createElement("p", null, "No more warnings will be given!")), navigateTo: function () { _this.props.navigateTo("/event/" + _this.props.event.subdomain + "/teams"); } }))),
                            React.createElement(Form.Item, null,
                                React.createElement(ButtonCancel, { isDisabled: isFetching, action: function () { return form.resetFields(); } }))),
                        React.createElement("div", { className: formStyles.buttonsRight },
                            React.createElement(Form.Item, null,
                                React.createElement(ButtonSubmit, { isFetching: isFetching }))))))));
    };
    return FormTeam;
}(React.Component));
export default Form.create()(FormTeam);



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormTeamPage/FormTeam/index.tsx
// module id = 1193
// module chunks = 0